import {Component, OnInit} from '@angular/core';
import {MyWalletTransactionHistoryStockistService} from '../../../shared/services/my-wallet-transaction-history-stockist.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';

@Component({
  selector: 'app-wallet-transaction-history',
  templateUrl: './wallet-transaction-history.component.html',
  styleUrls: ['./wallet-transaction-history.component.scss']
})
export class StockistWalletTransactionHistoryComponent implements OnInit {
  submitting = false;
  showSearch: any = false;
  searchForm: FormGroup;
  walletTransactions = [];
  bsConfig: Partial<BsDatepickerConfig>;
  pagination = {
    page: 1,
    total: null,
    perpage: 15,
    pages: null
  };

  constructor(public myWalletTransactionHistoryStockistService: MyWalletTransactionHistoryStockistService,
              private fb: FormBuilder) {
    this.bsConfig = Object.assign({}, {containerClass: 'theme-dark-blue', dateInputFormat: 'YYYY-MM-DD'}, {showWeekNumbers: false});
  }

  ngOnInit(): void {
    this.refresh();
  }

  refresh() {
    this.searchForm = this.fb.group({
      'transaction_no': [''],
      'receiver_id': [''],
      'credit': [''],
      'debit': [''],
      'receive_date': ['']
    });
    this.get();
  }

  get(params: any = {}) {
    params.page = this.pagination.page;
    params.perpage = this.pagination.perpage;
    this.submitting = true;
    this.walletTransactions = [];
    this.myWalletTransactionHistoryStockistService.get(params).subscribe(data => {
      if (data && data['data'].length > 0) {
        this.walletTransactions = data['data'];
        this.pagination = {
          page: data['pagination'].page,
          total: data['pagination'].total,
          perpage: data['pagination'].perpage,
          pages: data['pagination'].pages,
        };
        this.triggerScroll();
      } else {
        this.walletTransactions = [];
      }
      this.submitting = false;
    }, error => {
      this.submitting = false;
    });
  }

  triggerScroll() {
    window.scrollTo(500, 500);
    window.scrollTo(500, 0);
  }

  onPageChange(page) {
    this.pagination.page = page;
    this.get();
  }

  search() {
    this.pagination = {
      page: 1,
      total: null,
      perpage: 15,
      pages: null
    };
    let params = {
      'transaction_no': (this.searchForm && this.searchForm.value) ? this.searchForm.value.transaction_no : '',
      'receiver_id': (this.searchForm && this.searchForm.value) ? this.searchForm.value.receiver_id : '',
      'credit': (this.searchForm && this.searchForm.value) ? this.searchForm.value.credit : '',
      'debit': (this.searchForm && this.searchForm.value) ? this.searchForm.value.debit : '',
      'receive_date': (this.searchForm && this.searchForm.value) ? moment(this.searchForm.value.receive_date).format('YYYY-MM-DD') : ''
    };
    this.get(params);
  }
}
